import { Outlet } from "react-router-dom";

const PersonTagPage = () => {
    return (
        <Outlet />
    );
};

export default PersonTagPage;
